import { render } from "./WalkingAnimation.vue?vue&type=template&id=2b94e37c&scoped=true&ts=true"
import script from "./WalkingAnimation.vue?vue&type=script&lang=ts"
export * from "./WalkingAnimation.vue?vue&type=script&lang=ts"

import "./WalkingAnimation.vue?vue&type=style&index=0&id=2b94e37c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b94e37c"]])

export default __exports__